import {Outlet, useLocation} from "react-router-dom";
import MainHeader from "../components/mainHeader";
import MainFooter from "../components/mainFooter";
import { useEffect } from "react";

export default function HomeContainer() {
    return (
        <div className={'flex min-h-screen flex-col'}>
            <ScrollToTop />
            <MainHeader />
            <div className="flex-1">
                <Outlet />
            </div>
            <MainFooter />
        </div>
    )
}

export function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
